import { useMutation } from '@apollo/client';
import { DELETE_SERVER, SERVERS } from '../graphql/queries/server';
import { useFetchItems } from './useFetchItems';
export const useServers = ({ clientId }) => {
    const { items, error, loading } = useFetchItems({
        fetchQuery: SERVERS,
        dataProp: 'servers',
        skip: !clientId,
        spec: { clientId },
    });
    const [deleteServer] = useMutation(DELETE_SERVER, {
        refetchQueries: [{ query: SERVERS, variables: { spec: { clientId } } }],
    });
    return {
        items,
        error,
        loading,
        deleteServer,
    };
};
